import React from "react";
import keel from "../../assest/images/Keel.png";
export const Header = () => {
  return (
    <div>
      <div>
        <img src={keel} alt="no image" />
      </div>
    </div>
  );
};
